var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeatpostTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 135,
    viewBox: "0 0 194 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 194,
    height: 134,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 29.7778,
    width: 23.8222,
    height: 104.222,
    rx: 2,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.4667 2C89.4667 0.895431 90.3621 0 91.4667 0H102.356C103.46 0 104.356 0.89543 104.356 2V29.7778H89.4667V2Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.75 55.4062V63.875H114.562V55.4062H145.75ZM134.812 43.3125V76.4375H125.625V43.3125H134.812Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.75 96.4062V104.875H114.562V96.4062H145.75ZM134.812 84.3125V117.438H125.625V84.3125H134.812Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatpostTel);
export default __webpack_public_path__ + "static/media/seatpostTel.c5f713785ebb1f7d457fecf4fc4fefdf.svg";
export { ForwardRef as ReactComponent };